{
  "time.nav": "الوقت",
  "time.reports.nav": "التقارير",
  "time.duration.hoursMinutes": "{hours, number} س {minutes, number} د",
  "time.duration.hours": "{hours, number} س",
  "time.duration.minutes": "{minutes, number} د",
  "time.timer.start": "ابدأ المؤقت",
  "time.timer.stop": "أوقف المؤقت",
  "time.timer.startNamed": "ابدأ توقيت {title}",
  "time.timer.stopNamed": "أوقف توقيت {title}",
  "time.timer.runningOn": "المؤقت يعمل على {title}",
  "time.timer.stopped": "تم تسجيل {duration} على {title}",
  "time.bar.title": "ابدأ مؤقتًا",
  "time.bar.placeholder": "على ماذا تعمل الآن؟",
  "time.bar.loading": "جارٍ تحميل مهامك…",
  "time.bar.target": "المهمة أو المشروع",
  "time.bar.notePlaceholder": "ملاحظة (اختيارية)",
  "time.bar.runningTitle": "المؤقت يعمل",
  "time.target.projectWork": "عمل على المشروع",
  "time.target.projectWorkOn": "عمل على المشروع: {name}",
  "time.target.search": "ابحث في المهام والمشاريع",
  "time.target.empty": "لا توجد مهمة أو مشروع مطابق",
  "time.form.duration": "الوقت المستغرق",
  "time.form.durationHint": "مثل ١:٣٠ أو ٩٠ (دقيقة) أو ١٫٥ (ساعة)",
  "time.form.durationInvalid": "اكتب مدة بين دقيقة و٢٤ ساعة، مثل ١:٣٠.",
  "time.form.date": "اليوم",
  "time.form.note": "ملاحظة",
  "time.form.notePlaceholder": "ماذا أنجزت؟",
  "time.form.billable": "قابل للفوترة على العميل",
  "time.entry.nonBillable": "غير قابل للفوترة",
  "time.entry.edit": "تعديل السجل",
  "time.entry.delete": "حذف السجل",
  "time.entry.save": "حفظ",
  "time.entry.deleteTitle": "حذف سجل الوقت هذا؟",
  "time.entry.deleteBody": "سيُحذف وقت {duration} من المهمة ومن جدولك الزمني.",
  "time.estimate.of": "من {estimate} مقدّرة",
  "time.estimate.none": "مسجّلة · بدون تقدير",
  "time.estimate.left": "متبقٍّ {duration}",
  "time.estimate.over": "تجاوز بمقدار {duration}",
  "time.estimate.progress": "{logged} من {estimate} مقدّرة",
  "time.estimate.loggedOnly": "{logged} مسجّلة",
  "time.task.title": "الوقت",
  "time.task.log": "سجّل وقتًا",
  "time.task.logSubmit": "سجّل الوقت",
  "time.task.logged": "تم تسجيل {duration}",
  "time.task.mine": "وقتك: {duration}",
  "time.task.byPerson": "الوقت حسب الشخص",
  "time.task.empty": "لم يُسجَّل وقت بعد. ابدأ المؤقت أو سجّل الوقت يدويًا.",
  "time.task.emptyReadOnly": "لم يُسجَّل وقت على هذه المهمة بعد.",
  "time.task.loadError": "تعذّر تحميل الوقت المسجّل على هذه المهمة.",
  "time.task.showAll": "{count, plural, zero {لا توجد سجلات} one {اعرض السجل الوحيد} two {اعرض السجلين} few {اعرض السجلات الـ# كلها} many {اعرض الـ# سجلًا كلها} other {اعرض الـ# سجل كلها}}",
  "time.task.showFewer": "عرض أقل",
  "time.project.title": "الوقت",
  "time.project.billableShare": "{share} منه قابل للفوترة",
  "time.project.thisWeek": "هذا الأسبوع",
  "time.project.billable": "قابل للفوترة",
  "time.project.estimateVsActual": "المقدّر مقابل الفعلي في المهام المقدّرة",
  "time.project.topPeople": "الأكثر تسجيلًا للوقت",
  "time.project.yourTime": "وقتك",
  "time.project.empty": "لم يُسجَّل وقت على هذا المشروع بعد.",
  "time.project.openTimesheet": "افتح جدولك الزمني",
  "time.project.loadError": "تعذّر تحميل وقت هذا المشروع.",
  "time.log.open": "سجّل وقتًا",
  "time.log.title": "تسجيل وقت",
  "time.log.description": "أضف وقتًا قضيته دون تشغيل المؤقت.",
  "time.log.target": "المهمة أو المشروع",
  "time.log.targetMissing": "اختر مهمة أو مشروعًا.",
  "time.log.submit": "سجّل الوقت",
  "time.log.done": "تم تسجيل {duration}",
  "time.sheet.title": "الجدول الزمني",
  "time.sheet.titleOf": "الجدول الزمني: {name}",
  "time.sheet.subtitle": "أسبوعك من الأحد إلى السبت. اكتب الدقائق أو الساعات بصيغة س:دد في أي يوم، ويُحفظ عند مغادرة الخانة.",
  "time.sheet.weekNav": "الأسبوع",
  "time.sheet.previousWeek": "الأسبوع السابق",
  "time.sheet.nextWeek": "الأسبوع التالي",
  "time.sheet.thisWeek": "هذا الأسبوع",
  "time.sheet.weekRange": "{start} – {end}",
  "time.sheet.targetLabel": "{logged} من هدف الأسبوع {target}",
  "time.sheet.targetOf": "من {target} · {percent}",
  "time.sheet.billable": "قابلة للفوترة · {share}",
  "time.sheet.caption": "الجدول الزمني: {name}",
  "time.sheet.workColumn": "المهمة",
  "time.sheet.totalColumn": "الإجمالي",
  "time.sheet.dayTotals": "الإجمالي",
  "time.sheet.cellLabel": "{title}، {date}",
  "time.sheet.cellInvalid": "اكتب الدقائق (٩٠) أو الساعات والدقائق (١:٣٠)، حتى ٢٤ ساعة.",
  "time.sheet.addRow": "أضف صفًا",
  "time.sheet.addRowPlaceholder": "أضف مهمة أو مشروعًا إلى هذا الأسبوع…",
  "time.sheet.today": "اليوم",
  "time.sheet.dayEmpty": "لا وقت مسجّل",
  "time.sheet.weekend": "عطلة نهاية الأسبوع",
  "time.sheet.empty.title": "لا وقت مسجّل هذا الأسبوع بعد",
  "time.sheet.empty.body": "ابدأ مؤقتًا من الأعلى، أو سجّل وقتًا يدويًا، أو أضف صفًا واكتب في أي يوم.",
  "time.sheet.emptyOther.title": "لا وقت هذا الأسبوع",
  "time.sheet.emptyOther.body": "لا يوجد وقت مسجّل باسم {name} هذا الأسبوع يمكنك رؤيته.",
  "time.sheet.person": "جدول من",
  "time.sheet.choosePerson": "اختر شخصًا",
  "time.sheet.searchPeople": "ابحث عن شخص",
  "time.sheet.noPeople": "لا يوجد شخص مطابق",
  "time.report.title": "تقارير الوقت",
  "time.report.subtitle": "أين ذهب الوقت، {start} – {end}.",
  "time.report.export": "تصدير CSV",
  "time.report.range": "الفترة",
  "time.report.preset.this-week": "هذا الأسبوع",
  "time.report.preset.last-week": "الأسبوع الماضي",
  "time.report.preset.this-month": "هذا الشهر",
  "time.report.preset.last-month": "الشهر الماضي",
  "time.report.preset.custom": "مخصصة",
  "time.report.from": "من",
  "time.report.to": "إلى",
  "time.report.groupBy": "التجميع حسب",
  "time.report.group.project": "المشروع",
  "time.report.group.person": "الشخص",
  "time.report.group.client": "العميل",
  "time.report.group.task": "المهمة",
  "time.report.internal": "بدون عميل (داخلي)",
  "time.report.noTask": "عمل على المشروع (بدون مهمة)",
  "time.report.unnamed": "بدون اسم",
  "time.report.other": "أخرى",
  "time.report.summary.total": "إجمالي الوقت",
  "time.report.summary.billable": "الوقت القابل للفوترة",
  "time.report.summary.nonBillable": "{duration} غير قابلة للفوترة",
  "time.report.summary.share": "نسبة الفوترة",
  "time.report.scope.everyone": "وقت الجميع",
  "time.report.scope.yours": "وقتك، والمشاريع التي تقودها",
  "time.report.chartTitle": "التوزيع",
  "time.report.legend.billable": "قابل للفوترة",
  "time.report.legend.nonBillable": "غير قابل للفوترة",
  "time.report.tooltip": "{total} · {billable} قابلة للفوترة · {share}",
  "time.report.tableCaption": "الوقت حسب المجموعة، مع الوقت القابل للفوترة والنسبة",
  "time.report.columns.time": "الوقت",
  "time.report.columns.billable": "قابل للفوترة",
  "time.report.columns.share": "النسبة",
  "time.report.total": "الإجمالي",
  "time.report.csv.code": "الرمز",
  "time.report.csv.context": "المشروع",
  "time.report.csv.hours": "الساعات",
  "time.report.csv.billableHours": "الساعات القابلة للفوترة",
  "time.report.csv.share": "النسبة (%)",
  "time.report.empty.title": "لا وقت في هذه الفترة",
  "time.report.empty.body": "اختر فترة أخرى، أو سجّل وقتك من الجدول الزمني.",
  "time.errors.future": "هذا الوقت لم يمرّ بعد. سجّله بعد انتهائه.",
  "time.errors.tooOld": "الوقت الأقدم من ٦٠ يومًا مغلق. اطلب من قائد المشروع تعديله.",
  "time.errors.length": "مدة السجل بين دقيقة واحدة و٢٤ ساعة.",
  "time.errors.running": "أوقف المؤقت قبل تغيير مدته.",
  "time.errors.archived": "هذا المشروع مؤرشف، فلا يمكن تسجيل وقت عليه.",
  "time.errors.notRunning": "لا يوجد مؤقت يعمل.",
  "time.errors.alreadyRunning": "بدأ مؤقت آخر للتو. أعد التحميل وحاول مرة أخرى.",
  "time.errors.range": "اختر بداية قبل النهاية أو مساوية لها، وبفارق سنة على الأكثر.",
  "time.errors.forbidden": "لا يمكنك تسجيل وقت على هذا المشروع.",
  "time.errors.notFound": "تعذّر العثور على ذلك. ربما حُذف.",
  "time.errors.generic": "حدث خطأ في تسجيل الوقت. حاول مرة أخرى.",
  "time.sheet.you": "أنت",
  "time.sheet.byProject.title": "هذا الأسبوع حسب المشروع",
  "time.sheet.byProject.body": "أين ذهب وقت الأسبوع"
}
